(function() {
  window.addEventListener('load', () => {
    setTimeout(()=> {
      const klaviyoImgs = Array.from(document.querySelectorAll('img.needsclick'));

      if (klaviyoImgs && klaviyoImgs.length) {
        klaviyoImgs.forEach(element=>{
          element.setAttribute('alt', 'Pots and Pans, trusted brands for every kitchen.')
        });
      }

      const inputs = Array.from(document.querySelectorAll('input[type="email"].needsclick'));

      if (inputs && inputs.length) {
        inputs.forEach((input,index) => {
          const labelValue = input.getAttribute('aria-label');
          const parentNode = input.parentNode;
          const id = input.classList.value.replace(/\s+/g, '-').replace(/\//g, '-').toLowerCase();
          const inputLabel = document.createElement('label');

          input.removeAttribute('aria-label');
          input.setAttribute('aria-labelledby', `${id}-${index}-label`);
          inputLabel.id =`${id}-${index}-label`;
          inputLabel.setAttribute('for', input.id);
          inputLabel.textContent = labelValue;
          inputLabel.classList = 'visually-hidden';

          if (parentNode && inputLabel && input) parentNode?.insertBefore(inputLabel, input);
        })
      }

      const bvRatingsSummary = Array.from(document.querySelectorAll('.bv_ratings_summary'));

      if (bvRatingsSummary && bvRatingsSummary.length) {

        bvRatingsSummary.forEach((element,index) => {
          const labelValue = element.getAttribute('aria-label');
          const elementTextContent = element.textContent;

          element.setAttribute('aria-label', `${labelValue} ${elementTextContent}`);
        })
      }

      const gridient = Array.from(document.querySelectorAll('#meta-pay-button__b, #meta-pay-button__a'))
      if (gridient && gridient.length) {
        gridient.forEach((element, index)=> {
          const id = element.id
          const newId = id+index

          element.id = newId

          Array.from(document.querySelectorAll(`[fill="url(#${id})"]`)).forEach(element => {
            element.setAttribute('fill', `url(#${newId})`)
          });
        })
      }

      //target="_blank"
      const targetBlankElements = Array.from(document.querySelectorAll('[target="_blank"]'))

      if (targetBlankElements.length) {
        targetBlankElements.forEach(element=>{
          if (!element.hasAttribute('title')) element.setAttribute('title', 'Opens in a new window')
        });
      }

      const deliverrElements = Array.from(document.querySelectorAll('deliverr'));
      const setAccessibilityAttr = (elements)=> {
        if (elements && elements.length) {
          for (const element of elements) {
            if (element.children.length > 0) {
              const uniqueId = element.getAttribute('data-unique-id'),
                form = element.querySelector('.deliverr-zip-form'),
                button = form.querySelector('.deliverr-zip-deliver-to'),
                modal = form.querySelector('.deliverr-zip-location-modal'),
                ariaControls = button.getAttribute('aria-controls'),
                // ariaLabel = button.textContent,
                modalId = modal.id;

              if (uniqueId) {
                button.setAttribute('aria-controls', `${ariaControls}-${uniqueId}`);
                modal.setAttribute('id', `${modalId}-${uniqueId}`);
              }
              // button.setAttribute('aria-label', `${ariaLabel}`);
              button.removeAttribute('aria-label');
            }
          }
        }
      };

      const checkForChildren = (elements)=> {
        let timer;

        for (const element of elements) {
          if (element.children.length > 0) {
            clearTimeout(timer);
            setAccessibilityAttr(deliverrElements);

            return;
          }
        }

        timer = setTimeout(() => checkForChildren(elements), 1000);
      }

      checkForChildren(deliverrElements);

      const starDistribution = Array.from(document.querySelectorAll('.yotpo-star-distribution-row-wrapper'));

      if (starDistribution && starDistribution.length) {
        starDistribution.forEach(element=> {
          // element.setAttribute('aria-hidden', 'true');
          // element.setAttribute('tab-index', '-1');
          const elementId = Date.now() + Math.random()
          const elementStarDistributionLabel = document.createElement('label');

          element.removeAttribute('aria-label')
          element.setAttribute('aria-labelledby', `yotpo-star-rating-${elementId}`)
          element.setAttribute('role', `link`)
          elementStarDistributionLabel.textContent = 'Number of stars in relation to the total number of reviews: ';
          elementStarDistributionLabel.id = `yotpo-star-rating-${elementId}`;
          elementStarDistributionLabel.classList = 'visually-hidden';

          const parentElement = element.parentNode;
          if (parentElement && elementStarDistributionLabel && element) parentElement?.insertBefore(elementStarDistributionLabel, element);
        })
      }

      const svgArray = Array.from(document.querySelectorAll('.yotpo-search-label svg, .yotpo-dropdown-base svg, .yotpo-star-container svg, .reviewer-status svg, .star-container svg, .yotpo-reviews-widget-dropdown svg, .yotpo-radio-base svg, .yotpo-review-votes-icons svg, .yotpo-star-rating-icon, .yotpo-star-distribution svg'))

      if (svgArray.length) {
        svgArray.forEach((element, index )=>{

          element.setAttribute('aria-hidden', 'true');
          element.setAttribute('focusable', 'false');
        });
      }

      // SCarousel on HP (mobile)
      const carousel = document.querySelector('.home-section--content.featured-collection__content.flickity-enabled.is-draggable')
      if (carousel) {
        carousel.removeAttribute('tabindex');
      }

      // Video on HP
      const video = document.querySelector('iframe[title="DNH_Landing_Page_Supercut_v2"]')
      if (video) {
        video.removeAttribute('width')
        video.removeAttribute('height')
      }

      if (!document.body.classList.contains('template-product')) return;
      const yotpoReviewsSection = document.querySelector('.app-section-wrapper .yotpo-widget-instance');

      // Check if the yotpoReviewsSection exists (reviews main section on PDP)
      if (yotpoReviewsSection) {
        setTimeout(() => {
          const mediaFilterLabel = yotpoReviewsSection.querySelector('.yotpo-media-filter .yotpo-radio-base');
          const searchLabels = yotpoReviewsSection.querySelectorAll('.yotpo-search-label');
          const thumbnailButtons = Array.from(yotpoReviewsSection.querySelectorAll('.yotpo-single-thumbnail[role="button"]'));
          const yotpoNav = yotpoReviewsSection.querySelector('nav.yotpo-reviews-pagination-container');

          const searchLabelSpan = document.createElement('span');

          if (mediaFilterLabel) {
            const searchaMediaAcessibilityElement = document.createElement('span');
            const mediaFilterInput = mediaFilterLabel.querySelector('input#mediaInput');

            searchaMediaAcessibilityElement.classList = 'visually-hidden';
            searchaMediaAcessibilityElement.textContent = 'Search reviews with media';
            mediaFilterInput?.removeAttribute('aria-label');
            // mediaFilterInput.setAttribute('type', 'ccheckbox');

            if (mediaFilterLabel && searchaMediaAcessibilityElement && mediaFilterInput) mediaFilterLabel?.insertBefore(searchaMediaAcessibilityElement, mediaFilterInput);
          }

          searchLabels.forEach(searchLabel => {
            const mediaFilterInput = searchLabel.querySelector('input#searchInput');

            searchLabelSpan.textContent = 'Search reviews';
            searchLabelSpan.classList = 'visually-hidden';
            mediaFilterInput?.removeAttribute('aria-label');

            if (searchLabel && searchLabelSpan) searchLabel?.append(searchLabelSpan);
          });

          // Image in reviews
          thumbnailButtons.forEach((element, index)=> {
            element.setAttribute('type', 'button')
            element.removeAttribute('aria-selected')

            const imageInReviewsLabel = document.createElement('span');
            const elementId = Date.now() + Math.random();
            const parentElementThumbnailButton = element.parentNode;

            imageInReviewsLabel.textContent = `View image of Review (${index})`;
            imageInReviewsLabel.classList = 'visually-hidden';
            imageInReviewsLabel.id = elementId;

            element.setAttribute('aria-labelledby', elementId)
            if (parentElementThumbnailButton && imageInReviewsLabel && element) parentElementThumbnailButton?.insertBefore(imageInReviewsLabel, element);
          })

          // Yotpo pagination (reviews main section on PDP)
          if (yotpoNav) {
            const yotpoNavLabel = document.createElement('span');
            const parentElementYotpoNav = yotpoNav.parentNode;

            yotpoNavLabel.textContent = 'Load more product reviews';
            yotpoNavLabel.classList = 'visually-hidden';
            yotpoNavLabel.id = 'yotpoNavLabel';
            yotpoNav.setAttribute('aria-labelledby', 'yotpoNavLabel')
            yotpoNav.removeAttribute('aria-label');

            if (parentElementYotpoNav && yotpoNavLabel && yotpoNav) parentElementYotpoNav?.insertBefore(yotpoNavLabel, yotpoNav);
            yotpoNav.removeAttribute('role');
          }

          const smartFilters = Array.from(yotpoReviewsSection.querySelectorAll('.yotpo-smart-topic-filter'));
          smartFilters.forEach(smartFilter => {
            smartFilter.setAttribute('role', 'button');
            smartFilter.removeAttribute('aria-checked');
          });
          if(yotpoReviewsSection.querySelector('#scoreDropdownInput')) yotpoReviewsSection.querySelector('#scoreDropdownInput').removeAttribute('aria-label');

          const summaryIcons = document.querySelectorAll('.yotpo-star-rating-reviews-summary-icon svg');
          summaryIcons.forEach(summaryIcon => summaryIcon.setAttribute('title', 'Reviews summary'));

          const scoreOptions = document.querySelectorAll('.yotpo-score-option');
          scoreOptions.forEach(scoreOption => scoreOption.removeAttribute('role'));

          const dropdownContents = document.querySelectorAll('.yotpo-dropdown-content');
          dropdownContents.forEach(dropdownContent => dropdownContent.removeAttribute('role'));

          const reviewDates = document.querySelectorAll('.yotpo-review-date');
          reviewDates.forEach(reviewDate => reviewDate.removeAttribute('tabindex'));

          const scoreFilters = document.querySelectorAll('.yotpo-score-filter');
          scoreFilters.forEach(scoreFilter => scoreFilter.removeAttribute('tabindex'));
        }, 1000);
      }
    }, 500);
  });
})();